import { render, staticRenderFns } from "./RecordTypeRelease.vue?vue&type=template&id=dfe48da6&"
import script from "./RecordTypeRelease.vue?vue&type=script&lang=js&"
export * from "./RecordTypeRelease.vue?vue&type=script&lang=js&"
import style0 from "./RecordTypeRelease.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports